import React from "react"

export default class EmptyProfilesDemolition extends React.Component 
{
    constructor(props) 
    {
        super(props);      

    }

    render() 
    {               
        return (
            <div className={"emptyprofiles "+this.site}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 blog">
                            <div className="post">                                
                                <div className="text">
                                    <h3>Hometown Demolition Contractors</h3>
                                    <div className="text">
                                        <div className="one">                                        
                                            <p>Hometown verifies demolition contractor credentials and collects trusted reviews on demolition companies in Hometown's across America. We make it simple for you to receive free estimates to demolish a home, garage, or commercial building. Just request a free quote and Hometown will forward your request on to a few of the most reputable contractors for demolition in your area.</p>
                                            <span>Fast and simple to receive demolition estimates!</span>
                                        </div>
                                        <ul>
                                            <li>Residential demolition</li>
                                            <li>Commercial demolition</li>
                                            <li>Swimming pool removal</li>
                                            <li>Concrete removal</li>
                                        </ul> 
                                    </div>  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        )
    }
}